@if (loading) {
  <div class="text-center">
    <nb-spinner></nb-spinner>
  </div>
}

@if (!loading) {
  <table class="stripe mt-2">
    <thead>
      <tr>
        <th class="d-none d-md-table-cell px-2">Prénom</th>
        <th class="d-none d-md-table-cell px-2">Nom</th>
        <th class="d-none d-md-table-cell px-2 col-email">Email</th>
        <th class="d-none d-xl-table-cell px-2 col-mini">Téléphone</th>
        <th class="d-none d-md-table-cell px-2">Rôle</th>
        <th class="d-none d-md-table-cell px-2">Types</th>
        <th class="d-none d-md-table-cell px-2 col-mini">Depuis</th>
        <th class="d-table-cell d-md-none px-2">Nom Prénom<br />Email / Téléphone / Rôle / Types / Depuis</th>
        <th class="col-action"></th>
      </tr>
    </thead>
    <tbody>
      @if (!users || users.length == 0) {
        <tr class="empty">
          <td colspan="8">Aucun utilisateur</td>
        </tr>
      }
      @for (user of users; track user) {
        <tr>
          <td class="d-none d-md-table-cell px-2">{{ user.firstname }}</td>
          <td class="d-none d-md-table-cell px-2">{{ user.lastname }}</td>
          <td class="d-none d-md-table-cell px-2 col-email">{{ user.email }}</td>
          <td class="d-none d-xl-table-cell px-2">{{ user.phone }}</td>
          <td class="d-none d-md-table-cell px-2">{{ user.role | roleLabel }}</td>
          <td class="d-none d-md-table-cell px-2">{{ getAnimalTypesLabel(user.animalTypeIds) }}</td>
          <td class="d-none d-md-table-cell px-2">
            <ng-container
              [ngTemplateOutlet]="invitationStatus"
              [ngTemplateOutletContext]="{ $implicit: user }"
            ></ng-container>
          </td>
          <td class="d-table-cell d-md-none px-2">
            {{ user.firstname }} {{ user.lastname }}<br />
            {{ user.email }}<br />
            {{ user.phone }}<br />
            <strong>{{ user.role | roleLabel }}</strong
              ><br />
              <strong>Types:</strong> {{ getAnimalTypesLabel(user.animalTypeIds) }}<br />
              <strong>Depuis :</strong>
              <ng-container
                [ngTemplateOutlet]="invitationStatus"
                [ngTemplateOutletContext]="{ $implicit: user }"
              ></ng-container>
            </td>
            <td class="actions col-action">
              @if (canEdit(user)) {
                <button
                  nbButton
                  status="primary"
                  class="transparent-button"
                  size="small"
                  (click)="editUserAction(user)"
                  >
                  <nb-icon icon="q-modifier" pack="custom"></nb-icon>
                </button>
              }
              @if (canDelete(user)) {
                <button
                  nbButton
                  status="primary"
                  class="transparent-button"
                  size="small"
                  (click)="deleteUserAction(user)"
                  >
                  <nb-icon icon="q-supprimer" pack="custom"></nb-icon>
                </button>
              }
            </td>
          </tr>
        }
      </tbody>
    </table>
  }

  <ng-template #invitationStatus let-user>
    @if (user.invitationAcceptedAt) {
      {{ user.invitationAcceptedAt | date: "dd/MM/yyyy" }}
    } @else {
      @if (user.invitationDeclinedAt) {
        <span class="status-declined"
          >Déclinée</span
          >
        } @else {
          <span class="status-pending">En attente</span>
        }
      }
    </ng-template>

    <button
      nbButton
      status="primary"
      shape="round"
      size="small"
      (click)="addUserAction()"
      title="Ajouter un utilisateur"
      class="mr-2 mt-2"
      >
      <nb-icon icon="q-ajout-utilisateur" pack="custom"></nb-icon> Ajouter un utilisateur
    </button>
